/**
 * @generated SignedSource<<d5273b0c942dd34989f434f8b89757a7>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type WidgetIntegrationTurnpikeResponseAcceptanceTimeNumber_integrationTurnpikeSummary$data = {
  readonly acceptedTimeAverageInMs: number | null;
  readonly " $fragmentType": "WidgetIntegrationTurnpikeResponseAcceptanceTimeNumber_integrationTurnpikeSummary";
};
export type WidgetIntegrationTurnpikeResponseAcceptanceTimeNumber_integrationTurnpikeSummary$key = {
  readonly " $data"?: WidgetIntegrationTurnpikeResponseAcceptanceTimeNumber_integrationTurnpikeSummary$data;
  readonly " $fragmentSpreads": FragmentRefs<"WidgetIntegrationTurnpikeResponseAcceptanceTimeNumber_integrationTurnpikeSummary">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "WidgetIntegrationTurnpikeResponseAcceptanceTimeNumber_integrationTurnpikeSummary",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "acceptedTimeAverageInMs",
      "storageKey": null
    }
  ],
  "type": "IntegrationTurnpikeSummary",
  "abstractKey": null
};

(node as any).hash = "9331ebb0d36a21176b8affe707f9611f";

export default node;
